import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_SUBMITTED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
});

const RECORD = generateSchema(TRACKING_SUBMITTED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SUBMITTED_SCHEMA);

export class SubmittedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.submitted;
  }

  get properties() {
    return this.toJS();
  }
}
